import { RouterModule, Routes } from '@angular/router';
import { ICreateLoginComponent } from '@components/i-create-login/i-create-login.component';
import { VerifyComponent } from '@components/verify/verify.component';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { ShipyardComponent } from './pages/home/shipyard/shipyard.component';
import { VesselPageComponent } from './pages/home/vessel-page/vessel-page.component';
import { VersionsHistoryComponent } from './pages/versions-history/versions-history.component';
import { ChannelComponent } from './pages/channels/channel.component';
import { EditorComponent } from './pages/editor/editor.component';
import { EditorViewerComponent } from './pages/editor-viewer/editor-viewer.component';
import { SettingsComponent } from './pages/home/settings/settings.component';
import { RecentPagesComponent } from './pages/home/recent-pages/recent-pages.component';
import { OpsSettingsComponent } from './pages/ops-settings/ops-settings.component';
import { FcuSettingComponent } from './pages/ops-settings/system-setting/fcu-setting/fcu-setting.component';
import { FcuSettingViewComponent } from './pages/ops-settings/system-setting/fcu-setting-view/fcu-setting-view.component';
import { DeviceManagmentComponent } from './pages/device-managment/device-managment.component';
import { DeviceListComponent } from './pages/device-list/device-list.component';
import { SystemSpecificationComponent } from './pages/system-specification/system-specification.component';
import { ElectronLoginComponent } from '@components/electron-login/electron-login.component';
import { CommunicationProtocolsComponent } from './pages/communication-protocols/communication-protocols.component';

export const appRoutes: Routes = [
    { path: 'iCreateLogin', component: ICreateLoginComponent },
    { path: 'electronLogin', component: ElectronLoginComponent },
    { path: 'verify', component: VerifyComponent, canActivate: [AuthGuard] },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: RecentPagesComponent },
            { path: 'settings', component: SettingsComponent },
            { path: 'device-managment', component: DeviceManagmentComponent },
            { path: 'communication-protocols', component: CommunicationProtocolsComponent },
            { path: ':shipyardId', component: ShipyardComponent },
            {
                path: ':vesselId/settings',
                component: OpsSettingsComponent,
                runGuardsAndResolvers: 'always',
                canDeactivate: [OpsSettingsComponent.CanDeactivate],
            },
            { path: ':vesselId/settings/:tab', component: OpsSettingsComponent },
            {
                path: ':vesselId/device-list',
                component: DeviceListComponent,
                canDeactivate: [DeviceListComponent.CanDeactivate],
            },
            {
                path: ':vesselId/specification',
                component: SystemSpecificationComponent,
                canActivate: [AuthGuard],
                canDeactivate: [SystemSpecificationComponent.CanDeactivate],
            },
            { path: ':shipyardId/:vesselId', component: VesselPageComponent },
            { path: ':shipyardId/:vesselId/:version/approve', component: VesselPageComponent },
        ],
    },

    {
        path: ':shipyardId/:vesselId/history',
        component: VersionsHistoryComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'channels/:shipyardId/:vesselId',
        component: ChannelComponent,
        canActivate: [AuthGuard],
        children: [{ path: 'repose', component: ChannelComponent }],
    },
    {
        path: 'editor/:vesselId',
        component: EditorComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'editor/:vesselId/viewer/:mimicId',
        component: EditorViewerComponent,
        canActivate: [AuthGuard],
    },
    {
        path: ':vesselId/fcu',
        component: FcuSettingComponent,
        canActivate: [AuthGuard],
    },
    { path: ':vesselId/fcu/:fcuId', component: FcuSettingComponent, canActivate: [AuthGuard] },
    {
        path: ':vesselId/fcu/:fcuId/view',
        component: FcuSettingViewComponent,
        canActivate: [AuthGuard],
    },
    { path: '', component: VerifyComponent },
    { path: '**', redirectTo: '/' },
];

export const routing = RouterModule.forRoot(appRoutes, {});
